import './App.css';
import { RouterProvider, createBrowserRouter, Outlet, useNavigate, useLocation } from 'react-router-dom';
import Login from './routes/login/Login';
import Events from './routes/events/Events';
import Event, { EventLoader } from './routes/events/Event';

import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './routes/navbar/Navbar';
import NewEvent from './routes/events/NewEvent';
import News from './routes/news/News';
import NewNews from './routes/news/NewNews';
import MapView from './routes/map/Map';
import { NewsEdit, NewsLoader } from './routes/news/NewsEdit';
import Info from './routes/info/Info';
import InfoEdit, { InfoLoader } from './routes/info/InfoEdit';
import InfoNew from './routes/info/InfoNew';
import Home from './routes/home/Home';
import { useEffect, useState } from 'react';

export const router = createBrowserRouter([
	{
		path: "/",
		element: <NavbarWrapper />,
		children: [
			{
				path: "/",
				element: <Home />,
			},
			{
				path: "/events",
				element: <Events />,
			},
			{
				path: "/events/:eventId",
				element: <Event />,
				loader: EventLoader,
			},
			{
				path: "/newEvent",
				element: <NewEvent />,
			},
			{
				path: "/login",
				element: <Login />,
			},
			{
				path: "/news",
				element: <News />,
			},
			{
				path: "/news/:newsId",
				element: <NewsEdit />,
				loader: NewsLoader,
			},
			{
				path: "/newNews",
				element: <NewNews />,
			},
			{
				path: "/info",
				element: <Info />,
			},
			{
				path: "/info/:infoPageId",
				element: <InfoEdit />,
				loader: InfoLoader,
			},
			{
				path: "/newInfo",
				element: <InfoNew />,
			},
			{
				path: "/map",
				element: <MapView />,
			},
		]
	},
]);

function NavbarWrapper() {
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (location.pathname === '/login') return;
		fetch(`${process.env.REACT_APP_API_URL}/auth/me`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		}).then(async (res) => {
			if (!res.ok) {
				const data = await res.json();
				throw new Error(data.message);
			}
			setIsLoggedIn(true);
			return res.json();
		}).catch(err => {
			setIsLoggedIn(false);
			navigate('/login', { state: { from: location.pathname } });
		});
	}, [location.key]);

	return (
		<div>
			<Navbar isLoggedIn={isLoggedIn} />
			<Outlet context={{ isLoggedIn }} />
		</div>
	)
};

export default function App() {
	return (
		<div className="App">
			<RouterProvider router={router} />
		</div>
	);
}

// export default App;
